import { createFileRoute, useRouter } from '@tanstack/react-router';
import { RoutePermissionGuard } from '@/components/molecules';
import { LeadFormContent } from '@/components/organisms/leads/LeadFormSheet';
import type { Lead } from '@/types/lead';

export const Route = createFileRoute('/_dashboard/dashboard/leads/new')({
  component: NewLeadPage,
});

function NewLeadPage() {
  const router = useRouter();
  const search = Route.useSearch();

  function closeToList() {
    void router.navigate({ to: '/dashboard/leads', search });
  }

  function handleSuccess(lead?: Lead) {
    if (lead?.id) {
      void router.navigate({
        to: '/dashboard/leads/$leadId',
        params: { leadId: lead.id },
        search: { ...search, tab: 'overview' },
      });
      return;
    }
    closeToList();
  }

  return (
    <RoutePermissionGuard
      permissions="leads:create"
      message="You do not have permission to create leads."
    >
      <LeadFormContent presentation="page" onClose={closeToList} onSuccess={handleSuccess} />
    </RoutePermissionGuard>
  );
}
